import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TimePipe } from '@app/pipes/time.pipe';
import { DepartmentModel } from '@app/reducers/orm/department/department.model';
import { ComplianceViolation } from '@app/reducers/orm/schedule-compliance/schedule-compliance.model';
import { ConflictTopic, ScheduleConflictModel } from '@app/reducers/orm/schedule-conflict/schedule-conflict.model';
import { ScheduleModel } from '@app/reducers/orm/schedule/schedule.model';
import { ShiftModel } from '@app/reducers/orm/shift/shift.model';
import { TeamModel } from '@app/reducers/orm/team/team.model';
import { Dictionary } from '@ngrx/entity';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '@sb/ui/icon';
import { PlanType } from '@shiftbase-com/ts-shared/models';
import { clsx } from 'clsx';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'schedule-item-tooltip',
  imports: [TranslatePipe, TimePipe, IconComponent],
  templateUrl: './schedule-item-tooltip.component.html',
})
export class ScheduleItemTooltipComponent {
  @HostBinding('class')
  hostClass = clsx('flex flex-col gap-3');
  @Input()
  schedule: ScheduleModel;
  @Input()
  shift: ShiftModel | undefined;
  @Input()
  mode: 'employee' | 'team' = 'employee';
  @Input()
  isDisabled = false;
  @Input()
  conflicts: Dictionary<ScheduleConflictModel[]> | null | undefined;
  @Input()
  violation: ComplianceViolation | undefined;
  @Input()
  scheduledDepartment: DepartmentModel | undefined;
  @Input()
  scheduledTeam: TeamModel | undefined;

  ConflictTopic = ConflictTopic;
  planType = PlanType;
}
